(function() {
  // jQuery on an empty object, we are going to use this as our Queue
  var ajaxQueue = $({});

  $.ajaxQueue = function(ajaxOpts) {
   // hold the original complete function
   var oldComplete = ajaxOpts.complete;

   // queue our ajax request
   ajaxQueue.queue(function(next) {

     // create a complete callback to fire the next event in the queue
     ajaxOpts.complete = function() {
       // fire the original complete if it was there
       if (oldComplete) oldComplete.apply(this, arguments);

       next(); // run the next query in the queue
     };

     // run the query
     $.ajax(ajaxOpts);
   });
  };

  $.fn.serializeObject = function()
  {
      var o = {};
      var a = this.serializeArray();
      $.each(a, function() {
          if (o[this.name]) {
              if (!o[this.name].push) {
                  o[this.name] = [o[this.name]];
              }
              o[this.name].push(this.value || '');
          } else {
              o[this.name] = this.value || '';
          }
      });
      return o;
  };
  
  $.fn.extend({ 
    //plugin name - animatemenu
    hasSCrollBar: function() {
      var $this = $(this).first();
      var hasVScroll =  $this.height() < $this.attr('scrollHeight')
      var hasHScroll =  $this.width() < $this.attr('scrollWidth')
      return {x: hasHScroll, y: hasVScroll }
    }
  });               
               
	// $.strPad(12, 5); // returns 00012
	// $.strPad('abc', 6, '#'); // returns ###abc
	$.toPaddedString = function(i,l,s) {
		var o = i.toString();
		if (!s) { s = '0'; }
		while (o.length < l) {
			o = s + o;
		}
		return o;
	};

	$.expr[':'].regex = function(elem, index, match) {
		var matchParams = match[3].split(','),
		    validLabels = /^(data|css):/,
		    attr = {
		        method: matchParams[0].match(validLabels) ? 
		        matchParams[0].split(':')[0] : 'attr',
		        property: matchParams.shift().replace(validLabels,'')
		    },
		    regexFlags = 'ig',
		    regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g,''), regexFlags);
		return regex.test(jQuery(elem)[attr.method](attr.property));
	}
})();
